export const en = {
    'approx-price-lower-boundary-label': 'from {approxPrice}',
    'info-line': "The cost and duration are specified approximately based on the expert's details"
};
